import { da as reactda } from '@ews/react-translations';

const da = {
...reactda
}
export default da
